import { useMutation, useQueryClient } from 'react-query'
import axios, { AxiosError } from 'axios'
import { McdApiResponse, McdApiErrorStateKeys, createPostApiBody } from './useMcdApi'

export interface McdApiMutationOptions {
}

/** 汎用MCD API通信フック（POST） */
export const useMcdApiMutation = <TResponseBody>(url: string, params?: Object, options?: McdApiMutationOptions) => {
  // console.log('[useMcdApiQuery]', {url, params, options})
  const queryClient = useQueryClient()
  return useMutation(
    [url, params],
    () => axios.post<McdApiResponse<TResponseBody>>(url, createPostApiBody(params)),
    {
      onSuccess: (res) => {
        // console.log({res})
        if (res.data.isError) {
          queryClient.setQueryData([McdApiErrorStateKeys.McdApiError], res.data.errorInfo)
          console.warn(McdApiErrorStateKeys.McdApiError, res.data.errorInfo)
        }
        return res as any
      },
      onError: (error: AxiosError) => {
        queryClient.setQueryData([McdApiErrorStateKeys.ApiCommunicationError], error)
        console.warn(McdApiErrorStateKeys.ApiCommunicationError, error)
      },
    }
  )
}

export default useMcdApiMutation
